import React, { createContext, useContext, useState } from 'react';

const DEFAULT_STATE = {
  isSearchActive: false,
  searchValue: '',
};

/* In scope of bugfix https://neimanmarcus.atlassian.net/browse/OSP-5472 */
const MarketingAssetContext = createContext();

MarketingAssetContext.displayName = 'MarketingAssetContext';

const MarketingAssetProvider = ({ children, initialState = DEFAULT_STATE }) => {
  const [isSearchActive, setSearchActive] = useState(initialState.isSearchActive);
  const [searchValue, setSearchValue] = useState(initialState.searchValue);

  const searchState = { active: [isSearchActive, setSearchActive], value: [searchValue, setSearchValue] };

  return <MarketingAssetContext.Provider value={searchState}>{children}</MarketingAssetContext.Provider>;
};

const useMarketingAssetState = () => {
  const context = useContext(MarketingAssetContext);
  if (context === undefined) {
    throw new Error('useMarketingAssetState must be used within MarketingAssetProvider');
  }

  return context;
};

export { useMarketingAssetState, MarketingAssetProvider };
